import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DeepdiveComponent } from './deepdive.component';


const routes: Routes = [
  {
    path: '',
    component: DeepdiveComponent
  },
  {
    path: ':id',
    component: DeepdiveComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DeepdiveRoutingModule { }
